export const AUTH_EVENT = 'arihant-auth-changed'

export function notifyAuthChanged() {
  try {
    window.dispatchEvent(new Event(AUTH_EVENT))
  } catch (e) {
    /* ignore */
  }
}

export function storeVal(key, value) {
  sessionStorage.setItem(key, value == null ? '' : String(value))
}

export function storeSession(item, meta = {}) {
  const permissions = item.permissions ?? meta.permissions ?? []
  const roleIds = item.role_ids ?? meta.role_ids ?? []
  const roleName = item.role_name ?? meta.role_name ?? ''
  const canAccessAdmin = item.can_access_admin ?? meta.can_access_admin ?? false
  const userRole = item.user_role ?? meta.role_id ?? ''
  const token = String(item.id)
  const isGuest =
    item.is_guest === 1 ||
    item.is_guest === true ||
    item.is_guest === '1' ||
    meta.is_guest === 1 ||
    meta.is_guest === true ||
    meta.is_guest === '1'

  storeVal('id', item.id)
  storeVal('token', token)
  storeVal('name', item.name)
  storeVal('first_name', item.first_name)
  storeVal('last_name', item.last_name)
  storeVal('pan_number', item.pan_number)
  storeVal('mobile', item.mobile)
  storeVal('address1', item.address1)
  storeVal('email_address', item.email_address)
  storeVal('email', item.email_address || '')
  storeVal('user_role', userRole)
  sessionStorage.setItem('role_ids', JSON.stringify(roleIds))
  sessionStorage.setItem('permissions', JSON.stringify(permissions))
  sessionStorage.setItem('can_access_admin', canAccessAdmin ? '1' : '0')
  storeVal('role_name', roleName)
  storeVal('is_guest', isGuest ? '1' : '0')
  const mustChange =
    item.must_change_password ?? meta.must_change_password ?? 0
  storeVal(
    'must_change_password',
    mustChange === 1 || mustChange === true || mustChange === '1' ? '1' : '0'
  )
  notifyAuthChanged()
}

export function isGuestSession() {
  const v = sessionStorage.getItem('is_guest')
  return v === '1' || v === 'true'
}

export function hasDonorSession() {
  return Boolean(sessionStorage.getItem('id'))
}

export function markDonationResumeCheckout() {
  sessionStorage.setItem('donation_resume_checkout', '1')
}

export function consumeDonationResumeCheckout() {
  const flag = sessionStorage.getItem('donation_resume_checkout')
  sessionStorage.removeItem('donation_resume_checkout')
  return flag === '1' || flag === 'true'
}

export function clearSession() {
  sessionStorage.clear()
  notifyAuthChanged()
}

/** Only allow same-app paths (no protocol or protocol-relative URLs). */
export function safeReturnPath(raw) {
  if (raw == null) return ''
  let path = String(raw).trim()
  if (!path) return ''
  try {
    path = decodeURIComponent(path)
  } catch (e) {
    return ''
  }
  if (!path.startsWith('/') || path.startsWith('//') || /[:\\]/.test(path)) {
    return ''
  }
  return path
}

export function loginPath(returnUrl) {
  const safe = safeReturnPath(returnUrl)
  if (!safe) return '/Login'
  return `/Login?returnUrl=${encodeURIComponent(safe)}`
}

export function signUpPath(returnUrl) {
  const safe = safeReturnPath(returnUrl)
  if (!safe) return '/SignUp'
  return `/SignUp?returnUrl=${encodeURIComponent(safe)}`
}

export function applyLoginResponse(res) {
  if (res?.status !== 'success' || !Array.isArray(res.response) || res.response.length === 0) {
    return false
  }
  storeSession(res.response[0], {
    role_id: res.role_id,
    role_ids: res.role_ids,
    role_name: res.role_name,
    permissions: res.permissions,
    can_access_admin: res.can_access_admin,
    must_change_password: res.must_change_password,
    is_guest: res.is_guest ?? res.response[0]?.is_guest ?? 0,
  })
  return true
}

export function needsPasswordChange() {
  const v = sessionStorage.getItem('must_change_password')
  return v === '1' || v === 'true'
}

export function setMustChangePassword(flag) {
  storeVal('must_change_password', flag ? '1' : '0')
  notifyAuthChanged()
}

export function forgotPasswordPath(returnUrl) {
  const safe = safeReturnPath(returnUrl)
  if (!safe) return '/ForgotPassword'
  return `/ForgotPassword?returnUrl=${encodeURIComponent(safe)}`
}

export function changePasswordPath(returnUrl) {
  const safe = safeReturnPath(returnUrl)
  if (!safe || safe === '/ChangePassword' || safe.startsWith('/ChangePassword?')) {
    return '/ChangePassword'
  }
  return `/ChangePassword?returnUrl=${encodeURIComponent(safe)}`
}
